import { generateActions } from '../../utils/HttpReducerHelper';

import {
  createBusiness,
  createBusinessEntities,
  searchCompany,
  CLEAR_COMPANIES,
  SEND_REPORT,
  DOWNLOAD_CREDIT_REPORT_PDF,
} from './add-new-wizzard.types';

const searchCompanyHTTPActions = generateActions(searchCompany);
export const requestSearchCompany = searchCompanyHTTPActions.request;
export const requestSearchCompanySuccess = searchCompanyHTTPActions.success;
export const requestSearchCompanyFailure = searchCompanyHTTPActions.failure;

const createBusinessHTTPActions = generateActions(createBusiness);
export const requestCreateBusiness = createBusinessHTTPActions.request;
export const requestCreateBusinessSuccess = createBusinessHTTPActions.success;
export const requestCreateBusinessFailure = createBusinessHTTPActions.failure;

const createBusinessEntitiesHTTPActions = generateActions(createBusinessEntities);
export const requestCreateBusinessEntities = createBusinessEntitiesHTTPActions.request;
export const requestCreateBusinessEntitiesSuccess = createBusinessEntitiesHTTPActions.success;
export const requestCreateBusinessEntitiesFailure = createBusinessEntitiesHTTPActions.failure;

export function sendCreditReport(companyNumber, promise) {
  return {
    type: SEND_REPORT,
    companyNumber,
    promise,
  };
}

export function downloadCreditReportPdf(companyNumber, promise) {
  return {
    type: DOWNLOAD_CREDIT_REPORT_PDF,
    companyNumber,
    promise,
  };
}

export function clearAddNewClientWizzardCompaniesList() {
  return {
    type: CLEAR_COMPANIES,
  };
}
